module.exports = __webpack_public_path__ + "static/media/206-gallery06.dfd33de5.jpg";